import React from 'react'
import Link from 'gatsby-link'

class HeroSmall extends React.Component {
  render() {
    return(
      <div>
        <section className="pfb-hero-small">
          <div className="pfb-title-container">
            <h1>{ this.props.location }</h1>
          </div>
        </section>
      </div>
    )
  }
}

export default HeroSmall



// WEBPACK FOOTER //
// ./src/components/HeroSmall/index.js